export default "__VITE_ASSET__CdVxLs40__"